export const PHONESIZE = 600;
export const USERNAME = "Thysma23";
